import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/vorsorge.jpg"

const Vorsorge = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Vorsorgeuntersuchung </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Die Vorsorgeuntersuchung bietet allen Personen ab dem 18. Lebensjahr mit Wohnsitz in Österreich einmal pro Jahr ein umfangreiches Untersuchungsprogramm.
                        Dieser Gesundheitscheck bringt persönliche Vorteile: Ergeben die medizinischen Untersuchungen erste Hinweise für eine Erkrankung, dann wurde Zeit gewonnen, um gegenzusteuern.
                        <br /><br />
                        Ein individuelles Beratungsgespräch soll über einen gesundheitsfördernden Lebensstil aufklären und Unterstützung bei Veränderungsbedarf bieten. Sie erfahren, wie Sie besser auf Ihre Gesundheit achten können.
                        <br /><br />
                        Weitere Information finden Sie auch unter <a href="!#">www.gesundheit.gv.at</a>.
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Vorsorge;